$(document).ready(function () {
    var countryCode = "#" + $("#CountryField").val();
    var stateField = "#" + $("#StateField").val();
    var mailingStateField = "#" + $("#MailingStateField").val();
    var sameAsPhysicalAddressField = "#" + $("#SameAsPhysicalAddressField").val();
    //$("#hiData").getAttribute("sf-data");
    $(document).on('change', '.country', function () {
        var ctr = $(this);
        loadCountryData(ctr);
        $('#dealeropportunity_mailingcountry').val(ctr.val());
    });

    $(countryCode).change(function () {
        var ctrl = $(this);
        var filterValue = $('option:selected', ctrl).length > 0 ? $('option:selected', ctrl).attr("data-filter-value") : '';
        $(stateField).val("");
        $(mailingStateField).val("");

        if (filterValue == "") {
            $("#form-group-state").addClass("hidden");
            $("#form-group-mailing-state").addClass("hidden");

        }
        else {
            $("#form-group-state").removeClass("hidden");

            if (!($(sameAsPhysicalAddressField)).is(":checked")) {
                $("#form-group-mailing-state").removeClass("hidden");
            }

            $(stateField).find("option").each(function () {
                var $this = $(this);
                if (($this.attr("data-filter-value") !== filterValue) && ($this.attr("data-filter-value") !== "")) {
                    $this.hide();
                } else {
                    $this.show();
                }
            });

            $(mailingStateField).find("option").each(function () {
                var $this = $(this);
                if (($this.attr("data-filter-value") !== filterValue) && ($this.attr("data-filter-value") !== "")) {
                    $this.hide();
                } else {
                    $this.show();
                }
            });
        }
    });

    //check box
    $(sameAsPhysicalAddressField).change(function () {
        if (this.checked) {
            $("#form-group-mailing-street").addClass("hidden");
            $("#form-group-mailing-address2").addClass("hidden");
            $("#form-group-mailing-address3").addClass("hidden");
            $("#form-group-mailing-city").addClass("hidden");
            $("#form-group-mailing-state").addClass("hidden");
            $("#form-group-mailing-zip").addClass("hidden");


        }
        else {
            var ctrl = $(countryCode);
            var filterValue = $('option:selected', ctrl).length > 0 ? $('option:selected', ctrl).attr("data-filter-value") : '';
            $("#form-group-mailing-street").removeClass("hidden");
            $("#form-group-mailing-address2").removeClass("hidden");
            $("#form-group-mailing-address3").removeClass("hidden");
            $("#form-group-mailing-address3").removeClass("hidden");
            $("#form-group-mailing-city").removeClass("hidden");
            $("#form-group-mailing-zip").removeClass("hidden");
            if (filterValue != "") {
                $("#form-group-mailing-state").removeClass("hidden");
            }
        }
    });

});